import Vue from 'vue'
import axios from 'axios'
import env from '@/config/env'

const axiosIns = axios.create({
  baseURL: env.baseURL,
})

axiosIns.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
  },
  error => Promise.reject(error)
);

axiosIns.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // Importação lazy pra evitar dependência circular com o router
      import('@/router').then(({ default: router }) => {
        if (router.currentRoute.name !== 'login') {
          router.push({ name: 'login' });
        }
      });
    }
    return Promise.reject(error);
  }
);

Vue.prototype.$http = axiosIns

export default axiosIns
